import Cookies from 'js-cookie'
import { getBankLists } from "@/api/bank";
import { unallocatedAll } from "@/api/app";

export default {
  state: {
    messageObj: null, // 发起对话

    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    bankLists: [],
    bankListsParams: {}, // bankLists 的参数也存起来用以判断不同情况是否需要再次请求接口

    // 红点泡泡
    reloadTime: 0,
    reloadMinuteTime: 0,
    unallocatedObj: {},
    intervalTime: 10000, // 豪秒数
    intervalMinuteTime: 60000, // 1分钟

    /* --- 仲裁提交凭证 --- */
    arbitrateUploadObj: {
      type: null, // pay or withdraw
      uploading: null,
      id: null,
      orderId: null,
      platformOrder: null,
      visible: null,
      pop: false,
      patchStatus: null
    },
    /* --- 仲裁提交凭证 --- */

    /* --- 列表栏位排序 --- */
    sortableObj: {},
    /* --- 列表栏位排序 --- */

    switchProjectObj: {}, // 切换项目
    reloadCurrentPageData: false, // 利用此变数来刷新当前页面
  },
  mutations: {
    // 个页触发重刷功能应该要把此变数再改回 false
    TOGGLE_RELOAD_CURRENT_PAGE_DATA: (state, data) => {
      if (data) {
        state.reloadCurrentPageData = data;
      } else {
        state.reloadCurrentPageData = !state.reloadCurrentPageData;
      }
    },
    SET_SORTABLE_OBJ: (state, data) => {
      state.sortableObj = data
    },
    SET_ARBITRATE_UPLOAD_OBJ: (state, data) => {
      state.arbitrateUploadObj = data
    },
    SET_STATE: (state, data) => {
      Object.keys(data).forEach(key => {
        state[key] = data[key]
      })
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    }
  },
  actions: {
    /* 取得左侧菜单泡泡数量
    */
    GetUnallocatedAll({ commit }) {
      unallocatedAll().then((res) => {
        // 清除 0 的 小红点
        Object.keys(res.data).forEach(key => {
          if (res.data[key] === 0) {
            delete res.data[key];
          }
        });
        commit('SET_STATE', {
          unallocatedObj: res ? res.data : {}
        });
      });
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    /* 取得银行列表，以利缓存 bankLists
    */
    ToggleBankLists({ commit, state }, params) {
      params = params ? params : {};
      // 注意每个页面可能请求参数不同，若是参数改变需要再次请求
      // if (state.bankLists.length > 0 && JSON.stringify(params) === JSON.stringify(state.bankListsParams)) { // 做缓存用
      if (false) { // 暂时不做缓存
        return state.bankLists;
      } else {
        return new Promise((resolve, reject) => {
          getBankLists(params).then(res => {
            // commit('SET_STATE', { bankListsParams: params })
            // 设定 state 资料
            commit('SET_STATE', { bankLists: res.data })
            resolve(state.bankLists)
          }).catch(err => {
            reject(err)
          })
        })
      }

    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js